import type { MutableRefObject } from "preact/compat";
import { useCallback } from "preact/hooks";

export function useComboboxBlur(
  ref: MutableRefObject<HTMLElement | null>,
  handleClose: () => void,
  isMobile?: boolean
) {
  const handleBlur = useCallback((event: FocusEvent) => {
    const relatedTarget = event.relatedTarget as HTMLElement;
    
    // If no related target, don't close (programmatic blur)
    if (!relatedTarget) {
      return;
    }

    // Don't close if focus moves to elements within the same combobox
    if (ref.current && ref.current.contains(relatedTarget)) {
      return;
    }

    // Don't close if focus moves to dropdown options
    if (relatedTarget.getAttribute('role') === 'option') {
      return;
    }

    // Don't close if focus moves to the combobox listbox
    if (relatedTarget.closest('.combobox-listbox')) {
      return;
    }

    // Close when focus moves outside the combobox
    if (ref.current && !ref.current.contains(relatedTarget)) {
      if (!isMobile) {
        handleClose();
      }
    }
  }, [ref, handleClose, isMobile]);

  return handleBlur;
}
